module.exports = __webpack_public_path__ + "img/left_white_arr.f557ed7b.svg";